import * as React from 'react'
import { Box } from '@mui/material'
import dayjs from 'dayjs'
import { sendParameters } from '../../../common/functions'
import FileUpload from '../../../components/file/FileUpload'
import FileViewWidget from '../../../components/file/FileView'
import TaskWrapper from './TaskWrapper'
import ContractFormFields from './ContractFormFields'

interface ContractPreparationWidgetProps {
  task: any
  isCanceled: boolean
}

export default function ContractPreparationWidget({
  task,
  isCanceled
}: ContractPreparationWidgetProps) {
  const [contractNumber, setContractNumber] = React.useState(
    task.meta?.contractNumber || ''
  )
  const [contractDate, setContractDate] = React.useState(
    task.meta?.contractDate || dayjs().format('YYYY-MM-DD')
  )
  const [contractSentDate, setContractSentDate] = React.useState(
    task.meta?.contractSentDate || dayjs().format('YYYY-MM-DD')
  )
  const [contractTrackingNumber, setContractTrackingNumber] = React.useState(
    task.meta?.contractTrackingNumber || ''
  )
  const [files, setFiles] = React.useState<any[]>([])

  const enabled = task.isActive && task.accessFlags.update && !isCanceled

  return (
    <TaskWrapper
      task={task}
      label="Юридический отдел"
      isCanceled={isCanceled}
      onSave={() =>
        sendParameters(
          task.paidServiceId,
          task.id,
          {
            contractNumber,
            contractDate,
            contractSentDate,
            contractTrackingNumber
          },
          files
        )
      }
    >
      <Box display="flex" flexDirection="column" gap={3}>
        <ContractFormFields
          contractNumber={contractNumber}
          onContractNumberChange={setContractNumber}
          contractDate={contractDate}
          onContractDateChange={setContractDate}
          contractSentDate={contractSentDate}
          onContractSentDateChange={setContractSentDate}
          contractTrackingNumber={contractTrackingNumber}
          onContractTrackingNumberChange={setContractTrackingNumber}
          disabled={!enabled}
          required
        />
        {enabled ? (
          <FileUpload
            files={files}
            onUpload={(file: any) => setFiles([...files, file])}
            onDelete={(id: number) =>
              setFiles(files.filter((file: any) => file.id !== id))
            }
          />
        ) : (
          <FileViewWidget files={task.files} />
        )}
      </Box>
    </TaskWrapper>
  )
}
